import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainMenuComponent } from './main-menu/main-menu.component';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NotFoundModule} from '../not-found/not-found.module';
import {CustomButtonModule} from '../../Elements/custom-button/custom-button.module';
import {MainNavBarModule} from '../../Elements/main-nav-bar/main-nav-bar.module';
import {FormListGeneratorModule} from '../../Elements/form-list-generator/form-list-generator.module';
import {DetailsDivModule} from '../../Elements/details-div/details-div.module';
import {MatRadioModule} from '@angular/material/radio';
import {IntroductionLetterRoutes} from './introduction-letter-routes';
import { BasicInformationComponent } from './basic-information/basic-information.component';
import {NewRequestComponent} from './new-request/new-request.component';
import { CreateIntroductionLetterComponent } from './create-introduction-letter/create-introduction-letter.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { SubsetRequestsComponent } from './subset-requests/subset-requests.component';
import { NewSubSetDialogComponent } from '../../Dialogs/new-sub-set-dialog/new-sub-set-dialog.component';
import { IntroductionLetterFormComponent } from '../../Dialogs/introduction-letter-form/introduction-letter-form.component';
import {FileUploadDivModule} from '../../Elements/file-upload-div/file-upload-div.module';
import {RecompenseFormComponent} from '../../Dialogs/recompense-form/recompense-form.component';



@NgModule({
  declarations: [
    MainMenuComponent,
    BasicInformationComponent,
    NewRequestComponent,
    CreateIntroductionLetterComponent,
    SubsetRequestsComponent,
    RecompenseFormComponent,
    IntroductionLetterFormComponent,
    NewSubSetDialogComponent
  ], imports: [
    CommonModule,
    RouterModule.forChild(IntroductionLetterRoutes),
    FormsModule,
    ReactiveFormsModule,
    NotFoundModule,
    CustomButtonModule,
    MainNavBarModule,
    FormListGeneratorModule,
    DetailsDivModule,
    MatRadioModule,
    MatDialogModule,
    MatButtonModule,
    FileUploadDivModule
  ],
  entryComponents: [
    NewSubSetDialogComponent,
    IntroductionLetterFormComponent,
    RecompenseFormComponent
  ]
})
export class IntroductionLetterModule { }
